import React from 'react'
import { ResponsiveLayout } from 'containers'
import { FlaggedWithRollout } from './FlaggedWithRollout'

const Flagged = () => (
  <ResponsiveLayout
    contentContainerStyles={{ overflow: 'hidden' }}
    content={<FlaggedWithRollout />}
  />
)

export default Flagged
